<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ cardTitle }}</span>
    </v-card-title>
    <v-card-text class="pt-0">
      <!-- 하루 전체 비근무, WORK_TYPE = NON_WORK -->
      <v-radio-group
        v-model="nonWork"
        :column="false"
        :disabled="isWorkDay || lateCheckbox || leaveCheckbox"
        :messages="(isWorkDay || lateCheckbox || leaveCheckbox) ? '점검 기록, 지각, 조퇴가 있을 때는 비근무 처리 할 수 없습니다.' : ''">
        <v-radio label="연차" value="ANNUAL_LEAVE"></v-radio>
        <v-radio label="병가" value="SICK_LEAVE"></v-radio>
        <v-radio label="공가" value="PUBLIC_LEAVE"></v-radio>
        <v-radio label="휴가" value="SPECIAL_LEAVE" class="ml-4"></v-radio>
        <v-radio label="결근" value="ABSENT"></v-radio>
        <v-radio label="N" value="NONE"></v-radio>
      </v-radio-group>

      <v-container grid-list-md text-xs-center>
        <v-layout wrap row align-center>
          <v-flex xs12>
            <v-text-field v-model="memo" label="메모" hide-details></v-text-field>
          </v-flex>

          <v-flex xs3><v-checkbox v-model="lateCheckbox" label="지각" :disabled="isAutoRestDay"></v-checkbox></v-flex>
          <v-flex xs4>
            <v-menu
              ref="lateTimePickerMenu"
              v-model="lateTimePickerMenu"
              :close-on-content-click="false"
              :return-value.sync="lateTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="lateTime"
                  label="출근시각"
                  :disabled="!lateCheckbox"
                  :error-messages="lateCheckbox && !lateTime ? '출근시각을 입력하세요.' : ''"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="lateTimePickerMenu"
                v-model="lateTime"
                :max="minAttendTime"
                full-width
                scrollable
                @click:minute="$refs.lateTimePickerMenu.save(lateTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5></v-flex>

          <template v-for="(attend, index) in tempAttends">
            <v-flex xs4 :key="`f1-${index}`">
              <v-menu
                ref="timePickerMenus"
                v-model="timePickerMenus[index]"
                :close-on-content-click="false"
                :return-value.sync="attend.time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="attend.time"
                    label="점검시각"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timePickerMenus[index]"
                  v-model="attend.time"
                  full-width
                  scrollable
                  @click:minute="$refs.timePickerMenus[index].save(attend.time)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs7 :key="`f2-${index}`">
              <v-combobox v-model="attend.place"
                label="충전소"
                :items="placeAliases">
              </v-combobox>
            </v-flex>
            <v-flex xs1 :key="`f3-${index}`">
              <v-icon @click="() => deleteAttend(index)">close</v-icon>
            </v-flex>
          </template>
          <v-flex xs12>
            <v-btn block @click="addRow"><v-icon>add</v-icon> 점검 추가</v-btn>
          </v-flex>

          <v-flex xs3><v-checkbox v-model="leaveCheckbox" label="조퇴" :disabled="isAutoRestDay"></v-checkbox></v-flex>
          <v-flex xs4>
            <v-menu
              ref="leaveTimePickerMenu"
              v-model="leaveTimePickerMenu"
              :close-on-content-click="false"
              :return-value.sync="leaveTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="leaveTime"
                  label="조퇴시각"
                  :disabled="!leaveCheckbox"
                  :error-messages="leaveCheckbox && !leaveTime ? '조퇴시각을 입력하세요.' : ''"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="leaveTimePickerMenu"
                v-model="leaveTime"
                :min="maxAttendTime"
                full-width
                scrollable
                @click:minute="$refs.leaveTimePickerMenu.save(leaveTime)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5></v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="blue darken-1" flat @click="onResetClick" :disabled="!hasCustomAttends">초기화 {{ cell && cell.reports && cell.reports.length > 0 ? `(${cell.reports.length})` : '' }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click="onCloseClick">취소</v-btn>
      <v-btn color="blue darken-1" flat @click="onSaveClick" :disabled="!savable">저장</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import DailyItem from './DailyItem'
import '@/assets/css/AttendanceDocument.css'

// WORK          = 정상근무
// VACATION      = 연차/휴가(연차·반차·휴가 구분은 vacationType)
// SICK          = 병가
// PUBLIC        = 공가
// LATE          = 지각
// EARLY_LEAVE   = 조퇴
// OUT           = 외출
// ABSENT        = 결근
// HOLIDAY       = 공휴일

export default {
  components: {
    'daily-item': DailyItem
  },
  props: {
    checker: {
      type: Object,
      default: () => ({})
    },
    placeAliases: {
      type: Array,
      default: () => ([])
    },
    cell: {
      type: Object,
      default: () => ({})
    },
    yearMonth: {
      type: String,
      default () {
        return moment().startOf('month').format('YYYY-MM')
      }
    }
  },
  data () {
    return {
      tempAttends: [],
      timePickerMenus: [],

      nonWork: '',

      lateCheckbox: false,
      lateTimePickerMenu: false,
      lateTime: '',

      leaveCheckbox: false,
      leaveTimePickerMenu: false,
      leaveTime: '',
      memo: ''
    }
  },
  computed: {
    cardTitle () {
      // {{ checker.name }} {{ yearMonth }} {{ cell.head.date }}
      if (this.cell) {
        const day = String(this.cell.head.date).padStart(2, '0')
        return this.yearMonth + '-' + day + ' : ' + this.checker.name
      } else {
        return ''
      }
    },
    hasCustomAttends () {
      if (this.isAutoRestDay && this.cell && this.cell.attend && this.cell.attend.attends.length === 0) {
        return false
      }

      if (!this.cell || !this.cell.attend) {
        return false
      }

      if (this.cell.reports.length !== this.cell.attend.attends.length ||
        this.cell.attend.workType === 'NON_WORK' ||
        this.cell.attend.workType === 'TIME_AFFECT'
      ) {
        return true
      }

      const originAttends = this.cell.reports.map(item => {
        const t = moment(item.created.toDate()).format('HH:mm')
        return { time: t, place: item.place.name }
      })

      const isSame = this.cell.attend.attends.every((att, index) => {
        const org = originAttends[index]
        return att.time === org.time && att.place === org.place
      })

      return !isSame
    },
    isWorkDay () {
      return this.tempAttends.length > 0
    },
    isAutoRestDay () {
      return this.cell && this.cell.attend && this.cell.attend.id === 'AUTO_REST_DAY'
    },
    dataChanged () {
      const cell = this.cell
      if (!cell) {
        return false
      }

      if (this.hasCustomAttends && cell.attend) { // 1) 기존 attend 데이터가 있을 때 (수정 모드)
        const oldAttend = cell.attend

        // if (this.cell.attend.id === 'AUTO_REST_DAY' && this.nonWork === 'PUBLIC_LEAVE') {
        //   return false
        // }

        // workType, status 변경 여부
        if (oldAttend.workType !== this.nonWork &&
            !(oldAttend.workType === 'WORK' && this.isWorkDay)
        ) {
          return true
        }

        // attends 배열 비교 (시간/장소)
        const oldList = oldAttend.attends || []
        const newList = this.tempAttends || []

        if (oldList.length !== newList.length) {
          return true
        }

        for (let i = 0; i < newList.length; i++) {
          if (oldList[i].time !== newList[i].time ||
              oldList[i].place !== newList[i].place) {
            return true
          }
        }

        return false
      } else if (!this.hasCustomAttends) { // 2) 기존 attend 데이터가 없고 reports 기반으로 비교 (최초 입력 모드)
        if (this.lateCheckbox && this.lateTime) { // 지각 처리 변경시
          return true
        } else if (this.leaveCheckbox && this.leaveTime) { // 조퇴 처리 변경시
          return true
        }

        const reportList = cell.reports || []
        const newList = this.tempAttends

        if (reportList.length !== newList.length) {
          return true
        }

        for (let i = 0; i < newList.length; i++) {
          const r = reportList[i]
          const defaultTime = moment(r.created.toDate()).format('HH:mm')
          const defaultText = r.place.name

          if (newList[i].time !== defaultTime ||
              newList[i].place !== defaultText) {
            return true
          }
        }
      }

      return false
    },
    savable () {
      // if (!this.dataChanged) {
      //   return false
      // }

      // if (this.cell && this.cell.attend &&
      //   this.cell.attend.id === 'AUTO_REST_DAY' &&
      //   ['PUBLIC_LEAVE', 'ANNUAL_LEAVE'].includes(this.nonWork)) {
      //     console.log('check 1')
      //   return false
      // }

      if (this.nonWork) {
        return true
      }

      if (this.lateCheckbox && !this.lateTime) {
        return false
      }

      if (this.leaveCheckbox && !this.leaveTime) {
        return false
      }

      if (!this.nonWork && !this.lateCheckbox && !this.leaveCheckbox && (
        this.tempAttends.length === 0 ||
        this.tempAttends.some(a => !a.time || !a.place)
      )) {
        return false
      }

      return true
    },
    minAttendTime () {
      if (!this.tempAttends || this.tempAttends.length === 0) {
        return ''
      }

      const toMin = (t) => {
        const [h, m] = t.split(':').map(Number)
        if (isNaN(h) || isNaN(m)) return null
        return h * 60 + m
      }

      const times = this.tempAttends
        .map(a => toMin(a.time))
        .filter(v => v !== null)

      if (times.length === 0) {
        return ''
      }

      const min = Math.min(...times) - 1

      const h = String(Math.floor(min / 60)).padStart(2, '0')
      const m = String(min % 60).padStart(2, '0')

      return `${h}:${m}`
    },
    maxAttendTime () {
      if (!this.tempAttends || this.tempAttends.length === 0) {
        return ''
      }

      const toMin = (t) => {
        const [h, m] = t.split(':').map(Number)
        if (isNaN(h) || isNaN(m)) return null
        return h * 60 + m
      }

      const times = this.tempAttends
        .map(a => toMin(a.time))
        .filter(v => v !== null)

      if (times.length === 0) {
        return ''
      }

      const max = Math.max(...times) + 1

      const h = String(Math.floor(max / 60)).padStart(2, '0')
      const m = String(max % 60).padStart(2, '0')

      return `${h}:${m}`
    }
  },
  watch: {
    cell: {
      handler (to, from) {
        // console.log('reports', to.reports)

        if (to && to.attend) {
          if (to.attend.workType === 'NON_WORK') {
            this.nonWork = to.attend.status
          } else if (to.attend.workType === 'TIME_AFFECT') {
            const lateAffect = to.attend.timeAffects.find(t => t.type === 'LATE')
            const earlyLeaveAffect = to.attend.timeAffects.find(t => t.type === 'EARLY_LEAVE')

            if (lateAffect) {
              this.lateCheckbox = true
              this.lateTime = to.attend.timeAffects.find(t => t.type === 'LATE').time
            }

            if (earlyLeaveAffect) {
              this.leaveCheckbox = true
              this.leaveTime = to.attend.timeAffects.find(t => t.type === 'EARLY_LEAVE').time
            }
          }

          if (to.attend.attends) {
            this.tempAttends = JSON.parse(JSON.stringify(to.attend.attends)) // TODO: deep copy??
          }

          this.memo = to.attend.memo || ''
        }
      },
      immediate: true
    },
    tempAttends: {
      handler (to, from) {
        if (to.length > 0) {
          this.nonWork = ''
        }
      },
      immediate: true
    },
    lateCheckbox (to, from) {
      if (to) {
        this.nonWork = ''
      }
    },
    leaveCheckbox (to, from) {
      if (to) {
        this.nonWork = ''
      }
    }
  },
  created () {
    // TODO: dialog 열리고 닫힐때 tempAttend 값 초기화 필요
  },
  methods: {
    onSaveClick () {
      let workType = ''
      let status = ''
      const timeAffects = []

      if (this.nonWork) {
        workType = 'NON_WORK'
        status = this.nonWork
      } else {
        if (this.tempAttends.length === 0 && !this.lateCheckbox && !this.leaveCheckbox) {
          workType = 'NON_WORK'
          status = 'NONE'
        } else {
          workType = 'WORK'
          status = 'WORK'

          if (this.lateCheckbox && this.lateTime) {
            workType = 'TIME_AFFECT'
            status = 'LATE'
            timeAffects.push({type: 'LATE', time: this.lateTime})
          }

          // else if 로 연결하지 않음 '지각 후 조퇴' 의 경우 고려
          if (this.leaveCheckbox && this.leaveTime) {
            workType = 'TIME_AFFECT'
            status = 'EARLY_LEAVE'
            timeAffects.push({type: 'EARLY_LEAVE', time: this.leaveTime})
          }
        }
      }

      this.$emit('save', {
        workType,
        status,
        attends: this.tempAttends,
        timeAffects: timeAffects,
        memo: this.memo
      })
    },
    onCloseClick () {
      this.$emit('close')
    },
    onResetClick () {
      // TODO: 삭제하시겠습니까?
      this.$emit('reset')
    },
    onMinuteClick (index) {
      this.timePickerMenus[index] = false
    },
    deleteAttend (index) {
      this.tempAttends.splice(index, 1)
    },
    addRow () {
      this.tempAttends.push({time: '', place: ''})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Report/Attendance/DailyDataEditor.vue